import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=d2ba257c&"
import script from "./Sidebar.vue?vue&type=script&lang=js&"
export * from "./Sidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d2ba257c')) {
      api.createRecord('d2ba257c', component.options)
    } else {
      api.reload('d2ba257c', component.options)
    }
    module.hot.accept("./Sidebar.vue?vue&type=template&id=d2ba257c&", function () {
      api.rerender('d2ba257c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/General/Sidebar/Sidebar.vue"
export default component.exports